import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onPointerdown"]
const _hoisted_2 = { class: "au-modal__title" }
const _hoisted_3 = { class: "au-modal__content" }
const _hoisted_4 = { class: "au-modal__footer" }

import { deviceEvents } from 'util/device-util';
    import { ref, onUnmounted } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
        closeOnAndroidBack: Boolean, 
        closeOnOutsideClick: {
            type: Boolean,
            default: true
        },
        visible: Boolean,
        hideCancel: Boolean,
        hideSubmit: Boolean,
        cancelLabel: {
            type: String,
            default: "Close"
        },
        submitLabel: {
            type: String,
            default: "Got it!"
        }
    },
  emits: ['update:visible', 'cancel', 'submit', 'hidden'],
  setup(__props, { emit }) {

const props = __props

    
    

    const modal = ref<HTMLElement>();
    const handleOutsideClick = (e: PointerEvent) => {
        let target = <HTMLElement> e.target;
        if (props.closeOnOutsideClick && modal.value && target !== modal.value && !modal.value.contains(target)){
            emit('update:visible', false);
            emit('cancel');
        }
    }

    const handleCancel = () => {
        emit('update:visible', false);
        emit('cancel');
    }

    const handleSubmit = () => {
        emit('update:visible', false);
        emit('submit');
    }

    const handleBackButon = () => props.closeOnAndroidBack ? emit('update:visible', false) : null;
    deviceEvents.on('backButton', handleBackButon);
    onUnmounted(() => {
        deviceEvents.removeListener('backButton', handleBackButon);
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "blur",
    appear: "",
    onLeaveTo: _cache[1] || (_cache[1] = ($event: any) => (emit('hidden')))
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "au-modal-container",
        onPointerdown: _withModifiers(handleOutsideClick, ["stop","prevent"])
      }, [
        _createVNode(_Transition, {
          name: "slide-vertical",
          appear: "",
          mode: "out-in",
          onLeaveTo: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden')))
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              ref_key: "modal",
              ref: modal,
              class: "au-modal"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "title")
              ]),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "content")
              ]),
              _createElementVNode("div", _hoisted_4, [
                (!__props.hideCancel)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "au-modal__cancel",
                      onClick: handleCancel
                    }, _toDisplayString(__props.cancelLabel), 1))
                  : _createCommentVNode("", true),
                (!__props.hideSubmit)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "au-modal__dismiss ml2",
                      onClick: handleSubmit
                    }, _toDisplayString(__props.submitLabel), 1))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, __props.visible]
            ])
          ]),
          _: 3
        })
      ], 40, _hoisted_1), [
        [_vShow, __props.visible]
      ])
    ]),
    _: 3
  }))
}
}

})